import script from "./DuelPlayerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DuelPlayerCard.vue?vue&type=script&setup=true&lang=js"

import "./DuelPlayerCard.vue?vue&type=style&index=0&id=5b4c4f2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b4c4f2a"]])

export default __exports__